import * as React from 'react';
import { Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions, Button } from '@material-ui/core';


interface IProps {
  open: boolean
  onClose(): void
  onDiscard?(): void
  onSave?(): void
}

const UnsavedChangesModal = (props: IProps) => {
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle>Unsaved changes detected</DialogTitle>
      <DialogContent>
        <DialogContentText>
          You have unsaved changes.
        </DialogContentText>
        <DialogContentText>
          Please tell us what to do with your unsaved changes.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color="primary">
          Don't leave
                </Button>
        {props.onDiscard &&
          <Button onClick={props.onDiscard} color="primary">
            Discard
          </Button>
        }
        {props.onSave &&
          <Button onClick={props.onSave} color="primary">
            Save
          </Button>
        }
      </DialogActions>
    </Dialog>
  );
}

export default UnsavedChangesModal



// WEBPACK FOOTER //
// ./src/modules/shared/components/UnsavedChangesModal.tsx